// Per-scope cache — see docs/skeleton_count_caching.md. Scoped by checklist
// chip (today/week/overdue/someday/all) because the counts mean genuinely
// different things per chip (a handful "Today", dozens under "All") —
// a flat key would show whatever chip was last visited's count on a
// completely different one.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const DEFAULT_COUNT = 6

export function getCachedChecklistCount(scope) {
  return getCachedSkeletonCount(`tasks_checklist:${scope}`, DEFAULT_COUNT)
}

export function setCachedChecklistCount(scope, count) {
  setCachedSkeletonCount(`tasks_checklist:${scope}`, count)
}
